const React = require('react');
const SmallLogo = require('./../SmallLogo');
const isNode = (typeof process !== 'undefined');
const Collapse = isNode ? require('react-collapse') : <div/>;

class MobileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openSub: null
        };
    }

    render() {
        const { menuItems } = this.props;
        const { openSub, open } = this.state;

        const lis = menuItems.map((item, i) => {
            const anchorClasses = [].concat('mobile-menu__anchor', item.isActive ? 'mobile-menu__anchor--active' : null, item.children.length ? 'hasChildren' : null).join(' ');
            const listClasses = [].concat('mobile-menu__list-item').join(' ');
            {
                return item.isDropDown ? (
                    <li className={listClasses} key={i}>
                        <a className={anchorClasses} onClick={() => {
                            const newState = (openSub === i) ? null : i;
                            this.setState({ openSub: newState })
                        }}>
                            {(item.menuName) ? item.menuName : item.displayName}
                        </a>
                        {item.children.length && (
                        <Collapse isOpened={i === openSub}>
                            <ul className="mobile-menu__sub-menu">
                                {item.children.map(child => {
                                    return (
                                        <li className="mobile-menu__sub-item">
                                            <a className="mobile-menu__sub-anchor" href={child.link}>{(child.menuName) ? child.menuName : child.displayName}</a>
                                        </li>
                                    )
                                })}
                            </ul>
                        </Collapse>
                        )}
                    </li>
                ) : (
                   <li className={listClasses} key={i}>
                       <a href={item.externalLink ? item.externalLink : item.link} className={anchorClasses}>{(item.menuName) ? item.menuName : item.displayName}</a>
                   </li>
                )
            }
        });

        const overlayClasses = ['mobile-menu__overlay', open ? 'mobile-menu__overlay--open' : null].join(' ');

        return (
        <div className="mobile-menu">
            <div>
                <div className="mobile-menu__spacer"></div>
                <nav>
                    <a href={this.props.frontpageUrl}>
                        <SmallLogo className="mobile-menu__small-logo"/>
                    </a>
                    <div className="mobile-menu__burger-container" onClick={() => this.setState({ open: true })}>
                        <span>Meny</span>
                        <a className="mobile-menu__burger">
                            <span/>
                            <span/>
                            <span/>
                        </a>
                    </div>
                </nav>
            </div>
            <div className={overlayClasses}>
                <a onClick={() => this.setState({ open: false })}>
                    <svg className="mobile-menu__close" version="1.1"  x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000">
                        <g><path d="M500,623.8L159.9,963.9c-34.6,34.6-90.1,34.7-124.3,0.5c-34.4-34.4-34-89.8,0.5-124.3L376.2,500L36.1,159.9C1.5,125.3,1.4,69.8,35.6,35.6c34.4-34.4,89.8-34,124.3,0.5L500,376.2L840.1,36.1c34.6-34.6,90.1-34.7,124.3-0.5c34.4,34.4,34,89.8-0.5,124.3L623.8,500l340.1,340.1c34.6,34.6,34.7,90.1,0.5,124.3c-34.4,34.4-89.8,34-124.3-0.5L500,623.8z"/></g>
                    </svg>
                </a>
                <ul>
                    {lis}
                </ul>
            </div>
        </div>
        )
    }
}

module.exports = MobileMenu;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/MobileMenu/index.jsx